export enum EnumTipoQuestionarioUG {
    EntendendoEntidade = 1,
    MaturidadeRisco = 2
}